import React, { useEffect, useState } from "react";
import api from "../api";
import axios from "axios";
export const SignUp = () => {
  const [errors, setErrors] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [Country, setCountry] = useState("");
  const [State, setState] = useState("");
  const [PostalCode, setPostalCode] = useState("");
  const [CarBrands, setCarBrands] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [City, setCity] = useState("");
  const [Address, setAddress] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [lastemailError, setLastEmailError] = useState("");
  const [lastphonenumberError, setPhoneNumberError] = useState("");
  const [cityError, setCityError] = useState("");
  const [CountryError, setsCountryError] = useState("");
  const [addressError, setsAddresError] = useState("");
  const [StateError, setStateError] = useState("");
  const [PostalCodeError, setPostalCodeError] = useState("");  
  const [CarBrandsError, setCarBrandsrror] = useState("");  

  const handleSignUp = async (event) => {
    event.preventDefault();

    let hasErrors = false;

    if (firstName.trim() === "") {
      setFirstNameError("First name cannot be empty");
      hasErrors = true;
    } else {
      setFirstNameError("");
    }

    if (lastName.trim() === "") {
      setLastNameError("Last name cannot be empty");
      hasErrors = true;
    } else {
      setLastNameError("");
    }

    if (email.trim() === "") {
      setLastEmailError("Email cannot be empty");
      hasErrors = true;
    } else {
      setLastEmailError("");
    }

    if (PhoneNumber.trim() === "") {
      setPhoneNumberError("Phone Number cannot be empty");
      hasErrors = true;
    } else {
      setPhoneNumberError("");
    }

    if (City.trim() === "") {
      setCityError("City cannot be empty");
      hasErrors = true;
    } else {
      setCityError("");
    }

    if (Country.trim() === "") {
      setsCountryError("Country cannot be empty");
      hasErrors = true;
    } else {
      setsCountryError("");
    }

    if (Address.trim() === "") {
      setsAddresError("Address cannot be empty");
      hasErrors = true;
    } else {
      setsAddresError("");
    }

    if (State.trim() === "") {
      setStateError("State cannot be empty");
      hasErrors = true;
    } else {
      setStateError("");
    } 

    if (PostalCode.trim() === "") {
      setPostalCodeError("Postal Code cannot be empty");
      hasErrors = true;
    } else {
      setPostalCodeError("");
    } 

    if (CarBrands.trim() === "") {
      setCarBrandsrror("Car Brands cannot be empty");
      hasErrors = true;
    } else {
      setCarBrandsrror("");
    } 

    if (
      firstName.trim() !== "" &&
      lastName.trim() !== "" &&
      email.trim() !== "" &&
      PhoneNumber.trim() !== "" &&
      City.trim() !== "" &&
      State.trim() !== "" &&
      Address.trim() !== "" &&
      PostalCode.trim() !== "" &&
      CarBrands.trim() !== "" &&
      Country.trim() !== "" 
    ) {
      // Navigate to the desired page
    }

    if (hasErrors) {
      return; // Exit the function without making the API call
    }

    const requestData = {
      Buyer_First_Name: firstName,
      Buyer_Last_Name: lastName,
      Phone_Number: PhoneNumber,
      Email: email,
      Country: Country,
      Address: Address,
      State: State,
      City: City,
      Postal_Code: PostalCode,
      Car_Brands: CarBrands,
    };
    try {
      const response = await api.post("/auth/buyer/register", requestData);
      console.log("Registration successful:", response.data);
    } catch (error) {
      console.error("Error occurred during registration:", error);
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error; // Log the error response
        setErrors(errorMessage);
      } else {
        setErrors("Something went wrong");
      }
    }
  };

  return (
    <section className="seller-section">
      <div className="container">
        <div className="header-logo">
          <a href="/">
            <img src="images/logo.png" alt="logo" />
          </a>
        </div>
        <div className="seller-heading py-3">
          <h3 className="main-heading text-center">Buyer Sign Up</h3>
        </div>
        <form onSubmit={handleSignUp}>
          <div className="form-row">
            <div className="form-group col-md-6">
              <input type="text" placeholder="First Name*" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="form-control" />
              {firstNameError && (
                <div className="text-danger">{firstNameError}</div>
              )}
            </div>
            <div className="form-group col-md-6">
              <input type="text" placeholder="Last Name*" value={lastName} onChange={(e) => setLastName(e.target.value)}  className="form-control"/>
              {lastNameError && (
                <div className="text-danger">{lastNameError}</div>
              )}
            </div>
            <div className="form-group col-md-6">
              <input type="text" placeholder="Phone Number*" value={PhoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}   className="form-control" />
              {lastphonenumberError && (
                <div className="text-danger">{lastphonenumberError}</div>
              )}
            </div>
            <div className="form-group col-md-6">
              <input type="email" placeholder="Email*" value={email} onChange={(e) => setEmail(e.target.value)}  className="form-control"/>
              {lastemailError && (
                <div className="text-danger">{lastemailError}</div>
              )}
                </div>
                <div className="form-group col-md-6">
              <input type="text" placeholder="Address*" value={Address} onChange={(e) => setAddress(e.target.value)}  className="form-control" />
             {addressError && (
                <div className="text-danger">{addressError}</div>
              )}
            </div>
            <div className="form-group col-md-6">
              <input type="text" placeholder="Country*" value={Country} onChange={(e) => setCountry(e.target.value)}  className="form-control" />
               {CountryError && (
                <div className="text-danger">{CountryError}</div>
              )}
            </div>
            <div className="form-group col-md-6">
              <input type="text" placeholder="State*" value={State} onChange={(e) => setState(e.target.value)} className="form-control"  />
              {StateError && (
                <div className="text-danger">{StateError}</div>
              )}
               </div>
            <div className="form-group col-md-6">
              <input type="text" placeholder="City*" value={City} onChange={(e) => setCity(e.target.value)}   className="form-control" />
              {cityError && (
                <div className="text-danger">{cityError}</div>
              )}
            </div>
            <div className="form-group col-md-6">
              <input type="text" placeholder="Postal Code*" value={PostalCode} onChange={(e) => setPostalCode(e.target.value)}  className="form-control" />
              {PostalCodeError && (
                <div className="text-danger">{PostalCodeError}</div>
              )}
            </div>
            <div className="form-group col-md-6">
              <input type="text" placeholder="Car Brands*" value={CarBrands} onChange={(e) => setCarBrands(e.target.value)}  className="form-control" />
              
              {CarBrandsError && (
                <div className="text-danger">{CarBrandsError}</div>
              )}
            </div>
            <div className="form-group col-md-12 text-center mt-2">
            {errors && <p style={{ color: "red" }}>{JSON.stringify(errors)}</p>}
            </div>
            <button type="submit"  className="btn btn-primary w-100 py-3">Sign Up</button>
          </div>
          <div class="bottom-link pt-4 text-center">
            <p>
              {" "}
              Already have an account?{" "}
              <a href="/buyerlogin" class="w-100 py-3">
                Sign In
              </a>
            </p>
          </div>
         
        </form>
      </div>
    </section>
  );
};
